import { TimelineSection } from '../section-listing.model';

/**
 * A learner milestone event as a timeline section. sectionDate carries the event date;
 * createdByName is the creating user's full name (resolved server-side on list).
 */
export class MilestoneEventSection extends TimelineSection {
  eventDescription: string;
  createdByName: string;
}
